import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { ConfigContent } from "../../..";
import { TcfVendorConfigurationModel } from "../../../../models";
import { TcfVendorConfigurationForm } from ".";
import { ListTcfVendor, useListTcfVendorProvider } from "@devowl-wp/react-cookie-banner-admin";
import { useStores } from "../../../../store";
import { App } from "antd";
import { runInAction } from "mobx";
import { useLocationQuery, useRouteTcfVendorConfiguration } from "../../../../hooks";
import { useNavigate } from "react-router-dom";
import { __ } from "../../../../utils";
// TODO [TCF] where could we configure this? in the service cloud?
function useTcfVendorAdNetworks() {
    return [
        {
            identifier: "google-adsense",
            name: "Google AdSense",
            description: __("Google Adsense displays advertisements from various advertising partners (ad servers) on your website by integrating just one AdSense scripts. A complex bidding system decides which advertising partner receives the advertising slot in the end."),
            provider: "Google",
            logo: "https://assets.devowl.io/in-app/wp-real-cookie-banner/logos/google-a-dsense.svg",
            hasRealTimeApi: false,
            updatedAt: "2024-07-10T14:31:24.791Z",
            createContentBlockerForVendorId: 755,
            onCreateOrEditContentBlocker: ()=>{
                // TODO [TCF] this should be more generic
                window.location.href = `#/blocker/new?force=google-adsense-tcf&navigateAfterCreation=${encodeURIComponent(`#/cookies/tcf-vendors`)}`;
            },
            lists: [
                {
                    name: __("Google Advertising Products only"),
                    description: __("Only Google can display ads booked e.g. via Google Ads. This means that you obtain less consent from your website visitors, but will not generate the optimum revenue."),
                    vendorIds: [
                        755
                    ]
                },
                {
                    name: __("Commonly used ad partners"),
                    description: __("Consent is requested for all advertising partners who display a particularly large amount of advertising via Adsense (list provided by Google). This increases your revenue and at the same time you obtain consent from a manageable number of TCF vendors."),
                    vendorIds: "1,4,9,10,11,12,13,15,16,22,23,24,25,27,28,34,37,39,42,44,50,59,60,68,69,71,72,73,76,77,81,82,84,85,91,93,95,97,98,109,110,115,122,126,129,130,132,136,139,140,147,156,161,163,168,192,195,213,226,228,241,243,246,253,264,273,275,278,281,284,293,294,304,308,312,315,317,328,345,373,381,384,388,394,397,402,409,415,416,447,452,468,506,512,544,559,587,606,631,657,667,734,755,758,759,762,767,772,793,806,827,832,853,929,1050,1296,1301,1334".split(",").map(Number),
                    isRecommended: true
                },
                {
                    name: __("All ad partners using Google Adsense"),
                    description: __("Consent is obtained for all advertising partners who display advertising via Adsense. This leads to maximum revenue, but data protectionists could question the effectiveness of the consent due to the excessive number of vendors."),
                    vendorIds: "1,2,4,8,9,10,11,12,13,14,15,16,20,22,23,24,25,26,27,28,29,30,31,33,34,37,39,42,44,44,46,47,48,50,53,55,56,58,59,60,61,62,66,68,69,71,72,73,75,76,77,80,81,82,83,84,85,90,91,92,93,94,95,97,97,98,100,101,104,108,109,110,111,115,115,120,122,122,126,127,129,130,130,131,132,133,134,136,138,139,140,141,142,143,147,147,148,150,151,153,154,155,156,157,159,160,161,163,168,173,174,178,184,185,192,193,194,195,196,199,203,203,205,206,211,213,215,216,217,224,226,227,228,231,232,235,237,238,239,241,242,243,244,246,248,249,251,252,253,254,255,259,263,264,270,273,274,275,276,278,279,280,281,282,284,285,293,293,294,297,298,301,304,308,311,312,314,315,316,317,318,319,321,323,325,326,328,329,331,333,336,337,343,345,347,350,350,354,358,361,368,371,373,374,377,378,380,381,382,384,387,388,394,397,402,409,410,412,413,415,416,418,422,424,427,430,434,434,435,436,438,440,444,447,448,450,452,454,459,468,469,471,473,475,479,486,488,490,491,493,495,496,497,498,501,502,506,507,508,509,511,512,516,517,519,524,527,528,531,534,535,536,539,541,544,546,549,550,551,553,554,556,559,561,568,569,570,571,572,573,580,581,584,587,591,591,596,597,598,601,606,606,610,612,615,617,618,620,621,624,625,626,628,631,639,644,646,647,648,649,652,653,655,656,657,658,662,663,665,666,667,671,673,674,676,677,681,682,683,684,685,687,690,697,699,702,706,707,708,709,712,713,714,715,716,717,718,719,721,723,724,725,726,727,728,729,730,731,732,733,734,736,736,737,738,740,742,742,744,745,746,748,749,750,751,754,755,756,758,759,762,765,766,767,768,769,770,771,772,773,774,775,776,778,779,780,781,783,784,786,788,790,793,794,795,796,797,798,799,800,801,803,804,806,806,808,810,811,812,814,815,816,819,819,820,821,822,825,827,828,831,832,833,834,835,835,838,839,840,842,844,845,848,849,850,851,853,854,855,856,857,858,860,861,862,864,865,867,869,870,870,871,872,874,875,876,877,878,880,881,881,882,883,884,885,888,889,891,891,892,893,894,896,898,900,902,903,907,910,911,911,915,919,920,922,925,927,929,930,930,931,934,935,936,937,938,941,943,944,946,950,950,951,952,953,954,955,956,957,958,959,961,962,963,964,965,966,967,968,969,970,972,973,975,976,978,982,987,990,991,993,994,995,996,997,998,999,1001,1002,1003,1004,1005,1006,1009,1013,1014,1015,1016,1017,1019,1020,1021,1022,1024,1025,1026,1027,1028,1029,1029,1030,1031,1036,1037,1038,1039,1040,1041,1043,1044,1045,1047,1048,1049,1050,1051,1055,1057,1058,1059,1060,1060,1061,1062,1063,1064,1064,1067,1068,1069,1070,1071,1072,1073,1075,1076,1078,1079,1080,1081,1082,1083,1084,1085,1087,1090,1094,1097,1098,1100,1101,1103,1104,1106,1107,1108,1110,1111,1112,1113,1116,1116,1119,1120,1121,1122,1124,1126,1127,1129,1130,1132,1133,1134,1136,1137,1138,1139,1140,1141,1142,1144,1146,1147,1149,1151,1153,1154,1155,1155,1156,1157,1159,1160,1162,1162,1163,1164,1165,1167,1168,1169,1170,1171,1172,1173,1174,1174,1175,1176,1177,1178,1180,1181,1182,1183,1184,1185,1187,1188,1189,1190,1193,1195,1195,1196,1198,1199,1200,1201,1201,1202,1203,1204,1205,1206,1207,1208,1209,1210,1211,1212,1213,1214,1215,1216,1217,1218,1219,1220,1221,1222,1222,1224,1225,1226,1226,1227,1228,1229,1230,1231,1232,1234,1234,1235,1236,1238,1240,1241,1242,1243,1244,1245,1246,1247,1248,1249,1250,1251,1252,1253,1254,1255,1255,1256,1257,1258,1259,1260,1261,1262,1263,1263,1264,1265,1266,1267,1268,1268,1269,1270,1271,1272,1273,1274,1275,1276,1277,1278,1278,1279,1280,1280,1281,1282,1282,1283,1284,1285,1286,1287,1288,1289,1290,1291,1292,1293,1294,1295,1296,1296,1297,1297,1298,1299,1300,1301,1301,1302,1303,1304,1305,1306,1307,1308,1310,1310,1311,1311,1312,1313,1314,1315,1316,1317,1318,1319,1320,1321,1322,1323,1325,1326,1327,1328,1329,1330,1330,1331,1332,1333,1334,1334,1335,1336,1337,1338,1339,1340,1341,1342,1343,1344,1345,1346,1347".split(",").map(Number)
                }
            ]
        }
    ];
}
const TcfVendorSelector = observer(()=>{
    const { message } = App.useApp();
    const { tcfStore, optionStore } = useStores();
    const { busyVendors, fetchedAllVendorConfigurations, vendorConfigurations, vendors } = tcfStore;
    const [vendor, setVendor] = useState();
    const { link } = useRouteTcfVendorConfiguration();
    const { adNetwork: defaultCreateAdNetworkIdentifier } = useLocationQuery();
    const adNetworks = useTcfVendorAdNetworks();
    const navigate = useNavigate();
    useEffect(()=>{
        // Load all my configurations so we can show a "Already created"
        if (!tcfStore.fetchedAllVendorConfigurations) {
            tcfStore.fetchVendorConfigurations();
        }
        tcfStore.fetchVendors();
    }, []);
    const [ListTcfVendorContextProvider, listTcfVendorContextValue] = useListTcfVendorProvider({
        busy: busyVendors || vendors.size === 0 || !fetchedAllVendorConfigurations,
        vendorCount: vendors.size,
        rows: Array.from(vendors.values()).map((vendor)=>{
            const { vendorConfiguration } = vendor;
            return {
                busy: false,
                configuration: !!vendorConfiguration,
                vendor: vendor.data,
                blocker: vendorConfiguration ? vendorConfiguration.data.blocker : false
            };
        }),
        view: "vendors",
        defaultCreateAdNetworkIdentifier,
        adNetworks,
        onCreate: (param)=>{
            let { id } = param;
            return setVendor(vendors.get(id.toString()));
        },
        onBulkCreate: async (vendors, onQueueItemFinished, signal, bulkDone)=>{
            // Each TCF vendor deletion leads to fetching the current revision, suspend
            // this to avoid thousands of requests and do this after all vendors got deleted.
            const drafts = [];
            const promises = []; // we need to wait for `fromResponse` call in `persist` method
            for (const { id } of vendors){
                const draft = new TcfVendorConfigurationModel(vendorConfigurations, {
                    status: "publish",
                    meta: {
                        dataProcessingInCountries: "[]",
                        dataProcessingInCountriesSpecialTreatments: "[]",
                        restrictivePurposes: "[]",
                        vendorId: id
                    }
                });
                drafts.push(draft);
                promises.push(draft.persist(undefined, {
                    allowBatchRequest: {
                        onQueueItemFinished,
                        waitForPromise: bulkDone
                    },
                    settings: {
                        signal
                    }
                }).catch((e)=>message.error(e.responseJSON.message)));
            }
            await Promise.allSettled(promises);
            runInAction(()=>{
                for (const d of drafts){
                    if (d.key) {
                        d.collection.entries.set(d.key, d);
                    }
                }
            });
            await optionStore.fetchCurrentRevision();
            setTimeout(()=>navigate(link.slice(1)), 0);
        }
    }, {}, {
        inherit: [
            "busy",
            "vendorCount",
            "rows"
        ]
    });
    return vendor === undefined ? /*#__PURE__*/ _jsx(ConfigContent, {
        children: /*#__PURE__*/ _jsx(ListTcfVendorContextProvider, {
            value: listTcfVendorContextValue,
            children: /*#__PURE__*/ _jsx(ListTcfVendor, {})
        })
    }) : /*#__PURE__*/ _jsx(ConfigContent, {
        maxWidth: "fixed",
        children: /*#__PURE__*/ _jsx(TcfVendorConfigurationForm, {
            vendor: vendor
        })
    });
});
export { TcfVendorSelector, useTcfVendorAdNetworks };
